export default __webpack_public_path__ + "static/media/education.af975a15.svg";